import { jsx as _jsx } from "react/jsx-runtime";
import { BtnFactory, SIZE } from './BtnFactory';
export { SIZE };
export function SecondaryLink(props) {
    return _jsx(BtnFactory, { as: 'a', severity: 'secondary', ...props });
}
//# sourceMappingURL=SecondaryLink.js.map